"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _react2 = require("@tiptap/react");

var _useClickOutside = require("../hooks/useClickOutside");

var _context = require("../context");

var _form = require("../form");

var _hooks = require("../hooks");

var _layout = require("../layout");

var _liveAnnouncer = require("../live-announcer");

var _responsive = require("../responsive");

var _screenReaderOnly = require("../screen-reader-only");

var _statusIndicator = require("../status-indicator");

var _utils = require("../utils");

var _constants = require("./constants");

var _helperComponents = require("./helperComponents");

var _interfaces = require("./interfaces");

var _keyboardShortcuts = require("./keyboardShortcuts");

var _propTypes = require("./propTypes");

var _toolbar = require("./toolbar");

var _ToolbarImageModal = require("./toolbar/ToolbarImageModal");

var _ToolbarTableEditModal = require("./toolbar/ToolbarTableEditModal");

var _ToolbarTableModal = require("./toolbar/ToolbarTableModal");

var _useImageControl2 = require("./toolbar/useImageControl");

var _useTableControl2 = require("./toolbar/useTableControl");

var _utils2 = require("./utils");

var _core = require("@emotion/core");

var _excluded = ["aria-label", "aria-labelledby", "clipboardNotSupportedMessage", "content", "controls", "defaultContent", "defaultHeight", "disabled", "extensions", "getErrorText", "getExceededText", "getRecommendedText", "handleImageModalOnSubmit", "hasWordCounter", "id", "imageModalLocalization", "tablePopoverLocalization", "tableModalLocalization", "tableEditModalLocalization", "fontColorPopoverLocalization", "highlightPopoverLocalization", "isFullScreen", "keyboardShortcutsAltText", "keyboardShortcutsHintText", "keyboardShortcutsLocalization", "linkModalLocalization", "maxHeight", "onBlur", "onChange", "onCreate", "onFocus", "placeholder", "readOnly", "recommendedWordCount", "recommendedWordCountTokenType", "renderImageModalContent", "shouldDisableMarkdownShortcuts", "shouldWordCounterLiveAnnounce", "showToolbar", "statusIndicatorProps", "updateInstance"],
    _excluded2 = ["footerText"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var RichTextEditor = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var _ref$ariaLabel = _ref['aria-label'],
      ariaLabel = _ref$ariaLabel === void 0 ? _constants.defaultProps['aria-label'] : _ref$ariaLabel,
      ariaLabelledby = _ref['aria-labelledby'],
      clipboardNotSupportedMessage = _ref.clipboardNotSupportedMessage,
      content = _ref.content,
      controls = _ref.controls,
      defaultContent = _ref.defaultContent,
      defaultHeight = _ref.defaultHeight,
      disabled = _ref.disabled,
      extensionsProp = _ref.extensions,
      getErrorText = _ref.getErrorText,
      getExceededText = _ref.getExceededText,
      getRecommendedText = _ref.getRecommendedText,
      handleImageModalOnSubmit = _ref.handleImageModalOnSubmit,
      hasWordCounter = _ref.hasWordCounter,
      id = _ref.id,
      _ref$imageModalLocali = _ref.imageModalLocalization,
      imageModalLocalization = _ref$imageModalLocali === void 0 ? _constants.defaultProps.imageModalLocalization : _ref$imageModalLocali,
      _ref$tablePopoverLoca = _ref.tablePopoverLocalization,
      tablePopoverLocalization = _ref$tablePopoverLoca === void 0 ? _constants.defaultProps.tablePopoverLocalization : _ref$tablePopoverLoca,
      _ref$tableModalLocali = _ref.tableModalLocalization,
      tableModalLocalization = _ref$tableModalLocali === void 0 ? _constants.defaultProps.tableModalLocalization : _ref$tableModalLocali,
      _ref$tableEditModalLo = _ref.tableEditModalLocalization,
      tableEditModalLocalization = _ref$tableEditModalLo === void 0 ? _constants.defaultProps.tableEditModalLocalization : _ref$tableEditModalLo,
      _ref$fontColorPopover = _ref.fontColorPopoverLocalization,
      fontColorPopoverLocalization = _ref$fontColorPopover === void 0 ? _constants.defaultProps.fontColorPopoverLocalization : _ref$fontColorPopover,
      _ref$highlightPopover = _ref.highlightPopoverLocalization,
      highlightPopoverLocalization = _ref$highlightPopover === void 0 ? _constants.defaultProps.highlightPopoverLocalization : _ref$highlightPopover,
      _ref$isFullScreen = _ref.isFullScreen,
      isFullScreenDefault = _ref$isFullScreen === void 0 ? false : _ref$isFullScreen,
      _ref$keyboardShortcut = _ref.keyboardShortcutsAltText,
      keyboardShortcutsAltText = _ref$keyboardShortcut === void 0 ? _constants.defaultProps.keyboardShortcutsAltText : _ref$keyboardShortcut,
      _ref$keyboardShortcut2 = _ref.keyboardShortcutsHintText,
      keyboardShortcutsHintText = _ref$keyboardShortcut2 === void 0 ? _constants.defaultProps.keyboardShortcutsHintText : _ref$keyboardShortcut2,
      _ref$keyboardShortcut3 = _ref.keyboardShortcutsLocalization,
      keyboardShortcutsLocalization = _ref$keyboardShortcut3 === void 0 ? _constants.defaultProps.keyboardShortcutsLocalization : _ref$keyboardShortcut3,
      _ref$linkModalLocaliz = _ref.linkModalLocalization,
      linkModalLocalization = _ref$linkModalLocaliz === void 0 ? _constants.defaultProps.linkModalLocalization : _ref$linkModalLocaliz,
      maxHeight = _ref.maxHeight,
      _onBlur = _ref.onBlur,
      onChange = _ref.onChange,
      _onCreate = _ref.onCreate,
      _onFocus = _ref.onFocus,
      placeholder = _ref.placeholder,
      readOnly = _ref.readOnly,
      recommendedWordCount = _ref.recommendedWordCount,
      _ref$recommendedWordC = _ref.recommendedWordCountTokenType,
      recommendedWordCountTokenType = _ref$recommendedWordC === void 0 ? _hooks.TokenType.Words : _ref$recommendedWordC,
      renderImageModalContent = _ref.renderImageModalContent,
      shouldDisableMarkdownShortcuts = _ref.shouldDisableMarkdownShortcuts,
      shouldWordCounterLiveAnnounce = _ref.shouldWordCounterLiveAnnounce,
      showToolbar = _ref.showToolbar,
      statusIndicatorProps = _ref.statusIndicatorProps,
      updateInstance = _ref.updateInstance,
      forwardedProps = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var editorRef = (0, _react.useRef)(null);
  var viewport = (0, _responsive.useBreakpoints)();
  var isSmallScreen = viewport.matches.s;

  var _useContext = (0, _react.useContext)(_context.StencilContext),
      isRTL = _useContext.isRTL;

  var _useContext2 = (0, _react.useContext)(_context.StencilDialogContext),
      setHasOpenedDialog = _useContext2.setHasOpenedDialog;

  var selectionRange = (0, _react.useRef)({
    from: 0,
    to: 0
  });

  var _useState = (0, _react.useState)(isFullScreenDefault),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      isFullScreen = _useState2[0],
      setIsFullScreen = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      isToolbarFocusable = _useState4[0],
      setIsToolbarFocusable = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
      isKeyboardShortcutsOpen = _useState6[0],
      setIsKeyboardShortcutsOpen = _useState6[1];

  var _useState7 = (0, _react.useState)(false),
      _useState8 = (0, _slicedToArray2.default)(_useState7, 2),
      shouldLiveAnnounce = _useState8[0],
      setShouldLiveAnnounce = _useState8[1];

  var _useState9 = (0, _react.useState)(_interfaces.RTEModals.None),
      _useState10 = (0, _slicedToArray2.default)(_useState9, 2),
      modalToMount = _useState10[0],
      setModalToMount = _useState10[1];

  var _useState11 = (0, _react.useState)(null),
      _useState12 = (0, _slicedToArray2.default)(_useState11, 2),
      selectedImageNode = _useState12[0],
      setSelectedImageNode = _useState12[1];

  var hasSelectedTableNode = (0, _react.useRef)(false);

  var _useState13 = (0, _react.useState)(''),
      _useState14 = (0, _slicedToArray2.default)(_useState13, 2),
      selectedTableAnnouncement = _useState14[0],
      setSelectedTableAnnouncement = _useState14[1];

  var _useState15 = (0, _react.useState)([-1, -1]),
      _useState16 = (0, _slicedToArray2.default)(_useState15, 2),
      selectedCell = _useState16[0],
      setSelectedCell = _useState16[1];

  var _useState17 = (0, _react.useState)(''),
      _useState18 = (0, _slicedToArray2.default)(_useState17, 2),
      selectedImageAnnouncement = _useState18[0],
      setSelectedImageAnnouncement = _useState18[1];

  var _useState19 = (0, _react.useState)(false),
      _useState20 = (0, _slicedToArray2.default)(_useState19, 2),
      hasEnteredTable = _useState20[0],
      setHasEnteredTable = _useState20[1]; // Debouncing live announcement for better announcement


  var debounceAnnounce = (0, _react.useRef)((0, _utils.debounce)(setShouldLiveAnnounce, 1000)).current;
  var rteId = (0, _react.useMemo)(function () {
    return id || (0, _utils.getUniqueId)('rte');
  }, [id]);
  var keyboardShortcutsHintId = "".concat(rteId, "-shortcuts-hint");
  var selectedNodeLiveAnnouncement = (0, _react.useMemo)(function () {
    if (selectedImageNode || hasSelectedTableNode.current) {
      return (0, _core.jsx)(_liveAnnouncer.LiveAnnouncer, null, (0, _core.jsx)(_liveAnnouncer.LiveRegion, {
        "aria-live": "assertive",
        role: _liveAnnouncer.LiveRegionRole.Status
      }, (0, _core.jsx)(_screenReaderOnly.ScreenReaderOnly, null, !hasSelectedTableNode.current ? selectedImageAnnouncement : selectedTableAnnouncement)));
    }

    return null;
  }, [selectedImageNode, selectedImageAnnouncement, selectedTableAnnouncement]); // Preparing configs with extensions and toolbar items

  var configs = (0, _react.useMemo)(function () {
    return (0, _utils2.initializeEditorConfig)(controls, placeholder);
  }, [controls, placeholder]); // Helper to get word count before content update

  var getWordCount = (0, _react.useCallback)(function (editor) {
    return function () {
      return editor ? (0, _hooks.getRecommendedLengthCount)(recommendedWordCountTokenType, editor.getText()) : 0;
    };
  }, [recommendedWordCountTokenType]);
  var editor = (0, _react2.useEditor)({
    injectCSS: true,
    autofocus: false,
    content: content || defaultContent,
    editable: !disabled && !readOnly,
    onCreate: function onCreate(_ref2) {
      var editor = _ref2.editor;
      updateInstance && updateInstance();
      _onCreate && _onCreate((0, _utils2.instanceTransformer)(editor, getWordCount(editor)));
    },
    onFocus: function onFocus(_ref3) {
      var editor = _ref3.editor;
      updateInstance && updateInstance();

      if (editor.view.hasFocus()) {
        // Avoid async "highlight" marks unsetting
        var handler = function handler(_ref4) {
          var editor = _ref4.editor;
          var _editor$state$selecti = editor.state.selection,
              from = _editor$state$selecti.from,
              to = _editor$state$selecti.to; // Remove all left-over system browser highlight on focus

          editor.chain().setTextSelection({
            from: 0,
            to: editor.state.doc.content.size
          }).unsetHighlight().setTextSelection({
            from: from,
            to: to
          }).setMeta('addToHistory', false).focus().run();
          editor.off('selectionUpdate', handler);
        };

        editor.on('selectionUpdate', handler);
        editor.commands.setTextSelection(selectionRange.current || 0);
      } // Fixing safari shift-tab bug
      // Bug report: https://bugs.webkit.org/show_bug.cgi?id=24840


      editor.view.dom.setAttribute('tabindex', '-1');
      setIsToolbarFocusable(false);
      setHasOpenedDialog(false);
      _onFocus && _onFocus();
    },
    onBlur: function onBlur(_ref5) {
      var editor = _ref5.editor;
      updateInstance && updateInstance();

      if (!editor.view.hasFocus() && selectionRange.current) {
        var _selectionRange$curre = selectionRange.current,
            from = _selectionRange$curre.from,
            to = _selectionRange$curre.to;

        if (from !== to) {
          // Chrome and Firefox are keeping selection after blur, but no Safari.
          // To have the same behavior this removing selection after blur.
          var nativeSelection = window.getSelection();

          if (nativeSelection) {
            nativeSelection.removeAllRanges();
          }

          editor.chain().setHighlight().setMeta('addToHistory', false).run();
        }
      } // Fixing safari shift-tab bug ^


      editor.view.dom.setAttribute('tabindex', '0');
      _onBlur && _onBlur();
    },
    onSelectionUpdate: function onSelectionUpdate(_ref6) {
      var editor = _ref6.editor;
      updateInstance && updateInstance();
      hasSelectedTableNode.current = false;
      setHasEnteredTable(false);
      setSelectedTableAnnouncement('');
      var _editor$state$selecti2 = editor.state.selection,
          from = _editor$state$selecti2.from,
          to = _editor$state$selecti2.to; // @ts-ignore it is not possible for there to be no editorInstance at this point

      var _editorInstance$getSe = editorInstance.getSelection(),
          node = _editorInstance$getSe.node;

      if (node && node.type.name === 'image') {
        var _node$attrs$alt;

        setSelectedImageNode(node);
        var selectedImageAnnouncementName = (_node$attrs$alt = node.attrs.alt) !== null && _node$attrs$alt !== void 0 ? _node$attrs$alt : node.attrs.title;

        var _selectedImageAnnouncement = "Image ".concat(selectedImageAnnouncementName, " is editable");

        if (imageModalLocalization !== null && imageModalLocalization !== void 0 && imageModalLocalization.getImageEditableMessage) {
          _selectedImageAnnouncement = imageModalLocalization.getImageEditableMessage(selectedImageAnnouncementName);
        }

        setSelectedImageAnnouncement(_selectedImageAnnouncement);
      } else {
        setSelectedImageNode(null);
      }

      var content = editor.view.state.selection.content().content;
      var newTableAnnouncement = '';

      if (from === to) {
        var cellPosition = editor.view.state.selection.$anchor || editor.view.state.selection.$head; // traverse table tree to find the roote table node

        for (var i = -3; i <= 0; i++) {
          var tableNode = cellPosition.node(i);

          if (tableNode && tableNode.type.name === 'table') {
            if (!hasEnteredTable) {
              hasSelectedTableNode.current = true;
              newTableAnnouncement = "".concat(tableNode.attrs["aria-label"], " is editable");

              if (tableModalLocalization !== null && tableModalLocalization !== void 0 && tableModalLocalization.getTableEditableMessage) {
                newTableAnnouncement = tableModalLocalization.getTableEditableMessage(tableNode.attrs["aria-label"]);
              }

              setHasEnteredTable(true);
              break;
            }
          } else if (tableNode && tableNode.type.name === 'tableHeader') {
            var _tableNode$firstChild, _tableNode$firstChild2;

            var cellContentLength = (_tableNode$firstChild = tableNode.firstChild) !== null && _tableNode$firstChild !== void 0 && _tableNode$firstChild.textContent ? (_tableNode$firstChild2 = tableNode.firstChild) === null || _tableNode$firstChild2 === void 0 ? void 0 : _tableNode$firstChild2.textContent.length : 0; // announce only if selection is at the beginning of the cell or end of the cell

            var isCellInitial = cellPosition.parentOffset === 0;
            var isCellEnd = cellPosition.parentOffset === cellContentLength;
            var hasEnteredCell = false;

            if (isCellInitial && cellPosition.pos === selectedCell[0] - selectedCell[1]) {
              hasEnteredCell = true;
            }

            if (isCellEnd && cellPosition.pos - cellPosition.parentOffset === selectedCell[0]) {
              hasEnteredCell = true;
            }

            if (cellPosition.pos - cellPosition.parentOffset === selectedCell[0]) {
              hasEnteredCell = true;
            }

            if (!hasEnteredCell) {
              hasSelectedTableNode.current = true;
              newTableAnnouncement = 'Header cell';

              if (tableModalLocalization !== null && tableModalLocalization !== void 0 && tableModalLocalization.getTableHeaderCellMessage) {
                newTableAnnouncement = tableModalLocalization.getTableHeaderCellMessage();
              }

              setSelectedCell([cellPosition.pos - cellPosition.parentOffset, cellPosition.parentOffset]);
            }

            setHasEnteredTable(true);
            break;
          } else if (tableNode && tableNode.type.name === 'tableCell') {
            hasSelectedTableNode.current = true;
            setSelectedCell([cellPosition.pos - cellPosition.parentOffset, cellPosition.parentOffset]);
            setHasEnteredTable(true);
            break;
          } else {
            hasSelectedTableNode.current = false;
            setHasEnteredTable(false);
          }
        }
      } else {
        var selectedColumns = 0;
        var selectedRows = 0;
        var selectedTableCells = 0;
        content.forEach(function (node) {
          if (node && node.type.name === 'table') {
            selectedRows = node.childCount;
            selectedColumns = node.firstChild ? node.firstChild.childCount : 0;
            return;
          } else if (node && node.type.name === 'tableRow') {
            selectedRows += 1;
            selectedColumns = content.firstChild ? content.firstChild.childCount : 0;
          }

          return;
        }); // number of cells selected in table Row

        selectedTableCells = selectedRows * selectedColumns;

        if (selectedTableCells > 0) {
          newTableAnnouncement = selectedTableCells === 1 ? "".concat(selectedTableCells, " cell is selected in table") : "".concat(selectedTableCells, " cells are selected in table");

          if (tableModalLocalization !== null && tableModalLocalization !== void 0 && tableModalLocalization.getTableSelectedCellSingularMessage && tableModalLocalization !== null && tableModalLocalization !== void 0 && tableModalLocalization.getTableSelectedCellMessage) {
            newTableAnnouncement = selectedTableCells === 1 ? tableModalLocalization === null || tableModalLocalization === void 0 ? void 0 : tableModalLocalization.getTableSelectedCellSingularMessage() : tableModalLocalization === null || tableModalLocalization === void 0 ? void 0 : tableModalLocalization.getTableSelectedCellMessage(selectedTableCells);
          }

          hasSelectedTableNode.current = true;
        } else {
          hasSelectedTableNode.current = false;
        }
      }

      setSelectedTableAnnouncement(newTableAnnouncement);

      if (from && to) {
        selectionRange.current = {
          from: from,
          to: to
        };

        if (from === to) {
          setSelectedImageNode(null);
        }
      }
    },
    onUpdate: function onUpdate(_ref7) {
      var editor = _ref7.editor;
      updateInstance && updateInstance();
      onChange && onChange((0, _utils2.instanceTransformer)(editor, getWordCount(editor)));
    },
    editorProps: {
      handleDOMEvents: {
        // Toggling `shouldLiveAnnounce` while typing
        keydown: function keydown() {
          setShouldLiveAnnounce(false);
          return false;
        },
        keyup: function keyup() {
          debounceAnnounce(true);
          return false;
        }
      },
      handleKeyDown: function handleKeyDown(_, event) {
        var altOnlyPressed = event.altKey && !event.shiftKey && !event.metaKey; // Shortcut: Alt/Opt + F10 to focus Toolbar

        if (event.keyCode === _utils.EventKeyCodes.F10 && altOnlyPressed) {
          event.preventDefault();
          setIsToolbarFocusable(true);
          return true;
        } // Shortcut: Alt/Opt + 0 to open Keyboard Shortcuts


        if (event.keyCode === _utils.EventKeyCodes.DIGITS[0] && altOnlyPressed) {
          event.preventDefault();
          setIsKeyboardShortcutsOpen(true);
          setModalToMount(_interfaces.RTEModals.KeyboardShortcuts);
          return true;
        } // Shortcut: Alt/Opt + Enter to toggle fullscreen mode


        if (event.keyCode === _utils.EventKeyCodes.ENTER && altOnlyPressed) {
          event.preventDefault();
          setIsFullScreen(function (isFullScreen) {
            return !isFullScreen;
          });
          return true;
        }

        return false;
      },
      attributes: _objectSpread(_objectSpread(_objectSpread({
        role: 'textbox',
        id: rteId
      }, (0, _utils.pickAriaProps)(forwardedProps)), (0, _helperComponents.getAriaLabelProps)(ariaLabel, ariaLabelledby)), {}, {
        'aria-multiline': 'true',
        'aria-describedby': keyboardShortcutsHintId,
        dir: isRTL ? 'rtl' : 'ltr'
      })
    },
    extensions: [].concat((0, _toConsumableArray2.default)(configs.extensions), (0, _toConsumableArray2.default)(extensionsProp || [])),
    enableInputRules: !shouldDisableMarkdownShortcuts,
    enablePasteRules: !shouldDisableMarkdownShortcuts
  } // TODO: Add dependencies
  );

  var _useRecommendedLength = (0, _hooks.useRecommendedLength)({
    value: hasWordCounter && editor && editor.getText() || '',
    tokenType: recommendedWordCountTokenType,
    recommendedLength: recommendedWordCount || 0,
    getErrorText: getErrorText,
    getExceededText: getExceededText,
    getRecommendedText: getRecommendedText
  }),
      footerText = _useRecommendedLength.footerText,
      footerProps = (0, _objectWithoutProperties2.default)(_useRecommendedLength, _excluded2);

  var editorInstance = (0, _react.useMemo)(function () {
    return (0, _utils2.instanceTransformer)(editor, getWordCount(editor));
  }, [editor, getWordCount]);
  editorRef.current = editorInstance; // Passing editorContainerRef.current as Component ref

  (0, _react.useImperativeHandle)(ref, function () {
    if (editorInstance && editor && editor.view) {
      return {
        dom: editor.view.dom,
        editorInstance: editorInstance
      };
    }

    return null;
  }); // Handling editable state of the editor

  (0, _react.useLayoutEffect)(function () {
    if (editor) {
      if (disabled !== undefined || readOnly !== undefined) {
        editor.setEditable(!disabled && !readOnly);
      }
    }
  }, [editor, readOnly, disabled]); // Set content if new `content` prop passed

  (0, _react.useEffect)(function () {
    if (editor && content !== undefined) {
      editor.commands.setContent(content, true);
    }
  }, [editor, content]);

  var unselectEditorText = function unselectEditorText() {
    if (editor && editor.view.hasFocus()) {
      editor.chain().setTextSelection(selectionRange.current || 0).unsetHighlight().setMeta('addToHistory', false).focus().run();
      selectionRange.current = {
        from: 0,
        to: 0
      };
    }
  };

  var outsideRef = (0, _useClickOutside.useClickOutside)(unselectEditorText);

  var focusEditorContent = function focusEditorContent() {
    if (editor) {
      if (!editor.view.hasFocus()) {
        editor.chain().setTextSelection(0).focus(0).run();
      } else {
        unselectEditorText();
      }
    }
  };

  var handleEditorOnKeyDownCapture = function handleEditorOnKeyDownCapture(event) {
    var _document, _document$activeEleme, _editorRef$current;

    if (((_document = document) === null || _document === void 0 ? void 0 : (_document$activeEleme = _document.activeElement) === null || _document$activeEleme === void 0 ? void 0 : _document$activeEleme.tagName) === 'A' && event.keyCode === _utils.EventKeyCodes.ENTER) {
      editor === null || editor === void 0 ? void 0 : editor.setEditable(false);

      var handler = function handler() {
        editor === null || editor === void 0 ? void 0 : editor.setEditable(true);
        editor === null || editor === void 0 ? void 0 : editor.view.focus();
        event.target.removeEventListener('keyup', handler);
        event.target.removeEventListener('blur', handler);
      };

      event.target.addEventListener('keyup', handler);
      event.target.addEventListener('blur', handler);
    }

    if (event.shiftKey && event.keyCode === _utils.EventKeyCodes.ENTER && (_editorRef$current = editorRef.current) !== null && _editorRef$current !== void 0 && _editorRef$current.isActive(_interfaces.Commands.link)) {
      var _document$getSelectio, _document$getSelectio2;

      event.preventDefault();
      var anchorElement = (_document$getSelectio = document.getSelection()) === null || _document$getSelectio === void 0 ? void 0 : (_document$getSelectio2 = _document$getSelectio.focusNode) === null || _document$getSelectio2 === void 0 ? void 0 : _document$getSelectio2.parentNode;

      if (anchorElement) {
        anchorElement.setAttribute('tabindex', '1');
        editor === null || editor === void 0 ? void 0 : editor.setEditable(false);
        anchorElement.focus();

        var keyUpHandler = function keyUpHandler() {
          editor === null || editor === void 0 ? void 0 : editor.setEditable(true);
          anchorElement.removeEventListener('keyup', keyUpHandler);
        };

        var blurhandler = function blurhandler() {
          anchorElement.removeAttribute('tabindex');
        };

        anchorElement.addEventListener('keyup', keyUpHandler);
        anchorElement.addEventListener('blur', blurhandler);
      }
    }
  };

  var _useHighZoomLevel = (0, _responsive.useHighZoomLevel)({
    level: 175
  }),
      isInHighZoomLevel = _useHighZoomLevel.isInHighZoomLevel;

  var _useImageControl = (0, _useImageControl2.useImageControl)(editorInstance, setModalToMount, selectedImageNode),
      closeImageModal = _useImageControl.closeImageModal,
      imageModalProps = _useImageControl.imageModalProps,
      isImageModalOpen = _useImageControl.isImageModalOpen,
      _openImageModal = _useImageControl.openImageModal,
      setImage = _useImageControl.setImage;

  var _useTableControl = (0, _useTableControl2.useTableControl)(editorInstance, setModalToMount),
      closeTableModal = _useTableControl.closeTableModal,
      isTableModalOpen = _useTableControl.isTableModalOpen,
      openTableModal = _useTableControl.openTableModal,
      onSetRowsAndColumns = _useTableControl.onSetRowsAndColumns,
      closeTableEditModal = _useTableControl.closeTableEditModal,
      isTableEditModalOpen = _useTableControl.isTableEditModalOpen,
      openTableEditModal = _useTableControl.openTableEditModal,
      onSetTitle = _useTableControl.onSetTitle,
      tableTitle = _useTableControl.tableTitle;

  var isNotOnMobile = !isSmallScreen || isInHighZoomLevel;
  return (0, _core.jsx)(_react.default.Fragment, null, (selectedImageNode || hasSelectedTableNode.current) && selectedNodeLiveAnnouncement, (0, _core.jsx)(_helperComponents.EditorWrapper, (0, _extends2.default)({}, (0, _utils.pickDataProps)(forwardedProps), {
    disabled: disabled,
    isFullScreen: isFullScreen
  }), (0, _core.jsx)(_helperComponents.EditorBorderedContainer, {
    isFullScreen: isFullScreen,
    minHeight: defaultHeight,
    maxHeight: maxHeight,
    ref: outsideRef
  }, showToolbar && (0, _core.jsx)(_toolbar.Toolbar, {
    "aria-controls": rteId,
    clipboardNotSupportedMessage: clipboardNotSupportedMessage,
    disabled: disabled || readOnly,
    editorInstance: editorInstance,
    imageModalLocalization: imageModalLocalization,
    isFullScreen: isFullScreen,
    isSmallScreen: isSmallScreen,
    isToolbarFocusable: isToolbarFocusable,
    linkModalLocalization: linkModalLocalization,
    modalToMount: modalToMount,
    openImageModal: function openImageModal() {
      setModalToMount(_interfaces.RTEModals.Image);

      _openImageModal(selectedImageNode || undefined);
    },
    tablePopoverLocalization: tablePopoverLocalization,
    fontColorPopoverLocalization: fontColorPopoverLocalization,
    highlightPopoverLocalization: highlightPopoverLocalization,
    openTableModal: openTableModal,
    openTableEditModal: openTableEditModal,
    openKeyboardShortcuts: function openKeyboardShortcuts() {
      setModalToMount(_interfaces.RTEModals.KeyboardShortcuts);
      setIsKeyboardShortcutsOpen(true);
    },
    setIsFullScreen: setIsFullScreen,
    setModalToMount: setModalToMount,
    toolbarItems: configs.toolbarItems
  }), (0, _core.jsx)(_helperComponents.EditorContainer, {
    hasToolbar: !!showToolbar,
    hasWordCounter: !!hasWordCounter || !hasWordCounter && !!keyboardShortcutsHintText,
    disabled: disabled,
    isSmallScreen: isSmallScreen,
    isFullScreen: isFullScreen,
    isFocused: !!(editor && editor.isFocused)
  }, (0, _core.jsx)(_react2.EditorContent, {
    onKeyDownCapture: handleEditorOnKeyDownCapture,
    "data-test-component": "StencilEditorContent",
    editor: editor
  }), (0, _core.jsx)(_screenReaderOnly.ScreenReaderOnly, {
    hidden: true,
    id: keyboardShortcutsHintId
  }, keyboardShortcutsAltText), (0, _core.jsx)(_helperComponents.EditorContentBackground, {
    onMouseDown: focusEditorContent
  })), (0, _core.jsx)(_layout.Spacer, {
    margin: "auto 0 0 0"
  }), statusIndicatorProps && (0, _core.jsx)(_helperComponents.StatusContainer, {
    isSmallScreen: isSmallScreen
  }, (0, _core.jsx)(_statusIndicator.StatusIndicator, statusIndicatorProps)), !hasWordCounter && keyboardShortcutsHintText && isNotOnMobile && (0, _core.jsx)(_form.InputFooter, {
    borderRadius: isFullScreen ? 0 : _constants.FOOTER_BORDER_RADIUS
  }, keyboardShortcutsHintText), hasWordCounter && (0, _core.jsx)(_form.RecommendedLengthFooter, (0, _extends2.default)({
    borderRadius: isFullScreen ? 0 : _constants.FOOTER_BORDER_RADIUS,
    shouldLiveAnnounce: shouldWordCounterLiveAnnounce !== undefined ? shouldWordCounterLiveAnnounce : shouldLiveAnnounce,
    __additionalInfo: keyboardShortcutsHintText
  }, footerProps), footerText)), modalToMount === _interfaces.RTEModals.KeyboardShortcuts && (0, _core.jsx)(_keyboardShortcuts.KeyboardShortcutsModal, (0, _extends2.default)({
    setReturnFocus: (0, _utils2.setEditorReturnFocus)(editorInstance),
    isOpen: isKeyboardShortcutsOpen,
    close: function close() {
      return setIsKeyboardShortcutsOpen(false);
    },
    onClose: function onClose() {
      setModalToMount(_interfaces.RTEModals.None);
    }
  }, keyboardShortcutsLocalization))), modalToMount === _interfaces.RTEModals.Image && (0, _core.jsx)(_ToolbarImageModal.ToolbarImageModal, {
    close: closeImageModal,
    defaultValues: imageModalProps,
    handleOnSubmit: handleImageModalOnSubmit,
    isOpen: isImageModalOpen,
    localization: imageModalLocalization,
    onClose: function onClose() {
      setModalToMount(_interfaces.RTEModals.None);
    },
    onSetImage: setImage,
    renderImageModalContent: renderImageModalContent,
    setReturnFocus: (0, _utils2.setEditorReturnFocus)(editorInstance)
  }), modalToMount === _interfaces.RTEModals.Table && (0, _core.jsx)(_ToolbarTableModal.ToolbarTableModal, {
    close: closeTableModal,
    isOpen: isTableModalOpen,
    onClose: function onClose() {
      return setModalToMount(_interfaces.RTEModals.None);
    },
    localization: tableModalLocalization,
    onSetRowsAndColumns: onSetRowsAndColumns,
    setReturnFocus: (0, _utils2.setEditorReturnFocus)(editorInstance)
  }), modalToMount === _interfaces.RTEModals.EditTable && (0, _core.jsx)(_ToolbarTableEditModal.ToolbarTableEditModal, {
    close: closeTableEditModal,
    isOpen: isTableEditModalOpen,
    onClose: function onClose() {
      return setModalToMount(_interfaces.RTEModals.None);
    },
    localization: tableEditModalLocalization,
    tableTitle: tableTitle,
    onSetTitle: onSetTitle,
    setReturnFocus: (0, _utils2.setEditorReturnFocus)(editorInstance)
  }));
});

var _default = (0, _utils.composeStencilComponent)({
  baseComponent: RichTextEditor,
  defaultProps: _constants.defaultProps,
  description: 'Tiptap based Rich Text Editor.',
  displayName: 'RichTextEditor',
  propTypes: _propTypes.richTextEditorPropTypes
});

exports.default = _default;